import type { Dispatch, SetStateAction } from 'react';

export type Countable = {
    plural: string;
    singular: string;
};

export type Awaitable<T> = T | Promise<T>;

export type Entries<T> = {
    [K in keyof T]: [K, T[K]];
}[keyof T][];

// These are not all the MIME types, but just a list to get started
export type MIMEType = 'text/csv' | 'image/svg+xml' | 'text/plain' | 'application/zip';

export enum Operation {
    Create = 'Create',
    Edit = 'Edit',
    View = 'View',
}

export type Dictionary<T> = {
    [key: string]: T;
};

/**
 * Shortcut for `[SomeType, Dispatch<SetStateAction<SomeType>>]`;
 */
export type UseStateTuple<T> = [T, Dispatch<SetStateAction<T>>];
